import React from 'react';
import 'src/styles/styles.scss';
import "@gqlapp/global";
import Router from 'next/router';
import Base, { AppProps } from 'next/app';
import NextHead from 'next/head';
import mergeObject from '@gqlapp/utils/merge/mergeObject';
import { CacheProvider, EmotionCache } from '@emotion/react';
import { ApolloProvider } from 'react-apollo';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import createEmotionCache from '@gqlapp/ui/createEmotionCache';
import theme from '@gqlapp/ui/theme';
import WithApollo from '@gqlapp/ui/App';

//Route Events.
import NProgress from 'nprogress'; //nprogress module
NProgress.configure({ showSpinner: false });
Router.events.on('routeChangeStart', () => {
  NProgress.start();
  NProgress.set(0.8);
});

let timeout: any = null;

Router.events.on('routeChangeComplete', () => {
  clearTimeout(timeout);
  timeout = setTimeout(NProgress.done, 100);
});

Router.events.on('routeChangeError', () => NProgress.done());
// try{ process.on('warning', e => console.warn(e.stack)); }catch (e) {}

import createReduxStore from '@gqlapp/core-common/createReduxStore';
// @ts-ignore
import { Provider } from 'react-redux';
import NotificationProvider from "@gqlapp/base/Notification";

import clientModules from '@lib/clients';
// @ts-ignore
import config from "@config";
import { URLPattern } from "urlpattern-polyfill";

(async () => await clientModules.createApp(module))();


export interface MyAppProps extends AppProps {
  emotionCache?: EmotionCache;
  apollo?: any;
}


// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();

function AppComponent({ Component: BaseComponent, pageProps, apollo, emotionCache = clientSideEmotionCache }: MyAppProps & any){

  // console.warn('#######','AppComponent','XXX#', pageProps);
  try {
    const jssStyles = document.querySelector('#jss-server-side')
    if (jssStyles && jssStyles.parentNode)
      jssStyles.parentNode.removeChild(jssStyles)
  }catch (e) {}

  config?.settings.init();
  let req: any = pageProps.req;
  // @ts-ignore
  delete pageProps.res; delete pageProps.req; delete pageProps.apolloClient;

  pageProps = { ...pageProps, loadbar: NProgress };

  const store = createReduxStore(clientModules.reducers, {}, apollo);
  // @ts-ignore

  const  Component = (props: any) => clientModules.getWrappedRoot(<BaseComponent {...props} />, req);

  const ComponentWithProvider = () =>{
    // @ts-ignore
    return  <Provider store={store}>
      <ApolloProvider client={apollo}>
        <NotificationProvider {...pageProps}>{({ alert }: any) =>
            <Component {...pageProps} {...{ alert }} />}
        </NotificationProvider>
      </ApolloProvider>
    </Provider>
  }
  // @ts-ignore
  if(isTrue('DEBUG')){
    let start_time = pageProps?.start_time;
    let end_time = (new Date()).getTime(), run_time = end_time - start_time;
    error('####### APP Page', { start_time, end_time, run_time})
  }

  return (
    <CacheProvider value={emotionCache}>
      <NextHead>
        <meta name="viewport" content="width=978" key="viewport" />
      </NextHead>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <ComponentWithProvider />
      </ThemeProvider>
    </CacheProvider>
  );
}

/**
 * getInitialProps
 * @param appContext
 */
AppComponent.getInitialProps = async (appContext: any) => {
  let start_time = (new Date()).getTime();

  /** set default header* */
  serverSideProps(appContext.ctx);

  /**
   * load default args
   */
  let headers = appContext.ctx?.headers || {}
  let pathname = appContext.ctx?.pathname || '';
  let query = appContext.ctx?.query || {}
  let asPath = appContext.ctx?.asPath || '';
  let path   = asPath;
  // debug('######', { pathname, asPath, query })

  const pattern = new URLPattern({ pathname: '(.*)/:page/page(.html|)' });
  let res = pattern.exec({ pathname: asPath });
  if(res){
    const { pathname }= res || {}
    path = pathname.input;
    let groups = pathname.groups;
    for (let i = 0; i < 50; i++) {
      (groups[`${i}`]) && (delete groups[`${i}`]);
    }
    Object.assign(query, { ...groups});

    // debug('#####APP', res);
  }

  path = `${path}`.replace('.html', '');
  path = `${path}`.replace(/\/\d+\/page$/g, '');

  let { page } = query || {};
  Object.assign(query, { page: parseInt(page || 0) })

  let route_type: string;
  try{
    let routes = clientModules.route || {};
    // debug({ routes })
    Object.keys(routes).map((key: string)=>{
      let pathname = routes[key]?.props?.path;
      pathname = `${pathname}`.replace('.html', '')
      if(pathname){
        // debug('######', { pathname, asPath, path, query, route_type })
        const pattern = new URLPattern({ pathname });
        let res = pattern.exec({ pathname: path });
        if(res){
          try{
            route_type = key;
            let groups = res.pathname.groups || {}
            Object.assign(query, groups);
          }catch (e) {}
        }
      }
    })
  }catch (e) {}

  // debug('######', { pathname, asPath, path, query, route_type })
  // console.warn("\n\n\n\n\n\n");

  Object.assign(appContext.ctx, { start_time, path, asPath, query, route_type });

  if(isTrue('DEBUG')) {
    error('##############');
  }

  let pageProps = await Base.getInitialProps(appContext);

  if(isTrue('DEBUG')) {
    let end_time = (new Date()).getTime(), run_time = end_time - start_time;
    error('####### APP', {start_time, end_time, run_time})
  }
  /**
   * Assign default args
   */
  return mergeObject({ query, headers, path, asPath, pathname }, pageProps);
}

export default WithApollo(clientModules)(AppComponent);
